import { Pipe, PipeTransform } from '@angular/core';
import { GroupMemberStatus} from "../../shared/constants/group-constant";
@Pipe({
  name: 'groupMemberStatus'
})
export class GroupMemberStatusPipe implements PipeTransform {

  transform(value: string, isAdmin = false): string {
      switch (value) {
          case GroupMemberStatus.waitingForAdminApprove:
              return 'Waiting for admin approval';
          case GroupMemberStatus.waitingForApprove:
              return !isAdmin ? 'Waiting for approval' : 'Sent an invitation'
          default:
              return value;
      }
  }
}
